import React, { Component } from "react";
import ReactDOM from "react-dom";
import {
  Navbar,
  InputGroup,
  Nav,
  FormControl,
  Badge,
  Dropdown,
  Popover,
  Overlay,
  OverlayTrigger,
} from "react-bootstrap";

import points from "../../assets/profil/points.svg";
import logo from "../../assets/logo.png";
// import logoMobile from '../../assets/logo.svg';
import logoMobile from "../../assets/logo.png";
import logoArrowBack from "../../assets/logoArrowBack.svg";
import ic_search from "../../assets/ic_search.svg";
import talks from "../../assets/talks.svg";
import envMail from "../../assets/envoyer-un-mail.png";
// import notif from '../../assets/notif.svg';
import notif from "../../assets/newNotif.png";
import close from "../../assets/close.png";
import shopping from "../../assets/shopping.png";
import ic_coeur from "../../assets/ic_coeur.svg";
import plus from "../../assets/plus-icone.svg";
import defaultProfile from "../../assets/profil/utilisateur.png";
import panier from "../../assets/panier-header.png";

import message from "../../assets/message.png";
import notification from "../../assets/notification.png";
import down from "../../assets/down.png";
import Bise from "../../assets/icons/bise-white.svg";
import "./Header.css";

import { Link, withRouter } from "react-router-dom";

import {
  SearchResultWebPourToi,
  SearchResultWebCard,
} from "../SearchResultMobile/SearchResultMobile";
import { connect } from "react-redux";
import {
  friendRequestRefuse,
  friendRequestValidate,
  logout,
  searchUserByPseudo,
  searchAllPublic,
} from "../../services/stores/actions/compte";
import {
  getCounter,
  getRecentActivities,
  setCouterNotification,
  setCouterMessage,
  setTotalCounter,
  setCouterOrder,
} from "../../services/stores/actions/recentActivities";
import { getAllHashtags } from "../../services/stores/actions/hashtags";
import { getPageContent } from "../../services/stores/actions/services";
import InfiniteScroll from "react-infinite-scroll-component";
import dayjs from "dayjs";
import { getAllRequestFriend } from "../../services/stores/actions/compte";
import BounceLoader from "react-spinners/BounceLoader";
import { getContentByLike } from "../../services/stores/actions/content";
import {
  emptyAllPaniers,
  getAllPanier,
  setPaniersCounterReset,
  setPaniersCounter,
  setPaniersCounterAdd,
} from "../../services/stores/actions/panier";
import {
  ordersGet,
  updateNewItemsCount,
} from "../../services/stores/actions/orders";
import paniersReducers from "../../services/stores/reducers/paniersReducers";
import ModalHome from "../Modal/ModalHome";
import { findHashTag } from "../../utils/extracthashtags";
import { encryptionNotification } from "../../utils/encryption";
import { dataWithoutAdminAndModerator } from "../../utils/filteredData";
import ImageComponent from "../Image/image";
import { IoIosArrowBack } from "react-icons/io";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideHeader: false,
      showBox: false,
      token: null,
      pseudo: "",
      searchInput: "",
      activities: [],
      resultSearchUser: [],
      resultSearchTags: [],
      resultSearch: {},
      hashtags: [],
      contents: [],
      pourVous: [],
      allContentsLike: [],
      paniers: [],
      orders: [],
      listRequestFriends: [],
      isAccepted: false,
      isDeleted: false,
      showLoading: false,
      show: false,
      type: "",
      styleButtonNotification: {
        display: "none",
        position: "absolute",
        top: "0px",
        right: "10px",
        zIndex: 5,
      },
      isSearchHashTag: false,
      listUsers: [],
      timeoutInput: null,
      loadingSearch: false,
      targetPopOver: null,
    };
    this.box = React.createRef();
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  paniersGet = () => {
    getAllPanier().then((response) => {
      this.setState({ paniers: response });
      let data = {
        paniersCount: response.length,
      };
      // this.props.setPaniersCounterAdd();
      this.props.setPaniersCounter(data);
    });
  };

  ordersGet = () => {
    ordersGet().then((response) => {
      this.setState({ orders: response });
    });
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("click", this.handleOutsideClick);
    if (window.innerWidth < 700) {
      this.backListener = this.props.history.listen((location) => {
        if (
          location.pathname.includes("registration") ||
          location.pathname.includes("login") ||
          location.pathname.includes("motDePasseOublier") ||
          location.pathname.includes("new-publication-app") ||
          location.pathname.includes("publication-app")
        ) {
          this.setState({ hideHeader: true });
        } else {
          this.setState({ hideHeader: false });
        }
      });
    }

    getAllHashtags().then((response) => {
      this.setState({ hashtags: response });
    });
    if (this.props.isConnect) {
      this.getAllRecentActivities();
      this.getAllFriends();
      getContentByLike().then((response) => {
        this.setState({ allContentsLike: response.content });
      });
      this.paniersGet();
      this.ordersGet();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this?.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
      this.setState({ show: false });
    }
  }

  getAllFriends = () => {
    getAllRequestFriend().then((res) => {
      this.setState({
        listRequestFriends: res.data.data,
      });
    });
  };

  getAllRecentActivities = () => {
    getRecentActivities(1, 2).then((res) => {
      this.setState({ activities: res });
    });
  };

  isFocus = (test) => {
    this.setState({ showBox: test });
  };

  handleOutsideClick = (event) => {
    if (
      this.box &&
      this.box.current &&
      !this.box.current.contains(event.target)
    ) {
      this.isFocus(false);
    }
  };

  callbackTimeoutChange(value) {
    if (value !== "") {
      const searchText = value;
      this.setState({ isSearchHashTag: searchText[0] === "#" });
      searchAllPublic(
        searchText[0] === "#" ? searchText.slice(1).trim() : searchText.trim()
      ).then((response) => {
        clearTimeout(this.state?.timeoutInput);
        console.log(
          "search: ",
          searchText,
          response.data?.data.users.slice(0, 10)
        );
        this.setState((state) => ({
          ...state,
          timeoutInput: null,
          loadingSearch: false,
          resultSearch: response.data?.data,
          listUsers: dataWithoutAdminAndModerator(
            response.data?.data.users
          ).slice(0, 10),
        }));
      });
    }
  }

  handleSearchInputChange = (e) => {
    clearTimeout(this.state?.timeoutInput);
    this.setState({
      loadingSearch: true,
      listUsers: [],
      searchInput: e.target.value,
      timeoutInput: setTimeout(
        this.callbackTimeoutChange.bind(this, e.target.value),
        1000
      ),
    });
  };

  onRenderSearchForm = () => {
    return (
      <div
        className="d-none d-lg-block mr-0 mr-xl-5 search-form-header"
        ref={this.box}
        style={{ textAlign: "center" }}
      >
        <InputGroup
          className="mb-3"
          style={{ borderRadius: "125rem", border: "solid 1px #303030" }}
        >
          <button className="btn btn-search">
            <img src={ic_search} alt="" />
          </button>
          <FormControl
            placeholder="Search"
            style={{
              fontFamily: "KohinoorRegular",
              border: "0",
              borderRadius: "0rem 25rem 25rem 0",
            }}
            onFocus={() => this.isFocus(true)}
            onChange={this.handleSearchInputChange}
            value={this.state.searchInput}
          />
          <img
            src={close}
            alt=""
            className="pointer-cursor"
            width={`15px`}
            height={`15px`}
            style={{
              position: "absolute",
              top: "30%",
              right: "20px",
              zIndex: 8,
            }}
            onClick={() => {
              this.setState({ searchInput: "" });
            }}
          />
        </InputGroup>

        {this.state.showBox && (
          <div
            className={`${this.state.searchInput !== "" ? "results" : "d-none"} py-3 px-1`}
          >
            {this.state?.loadingSearch && (
              <div class="spinner-border m-auto" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            )}
            {this.state?.resultSearch?.contents && (
              <div className="resultList row mx-0 px-0">
                {this.state?.isSearchHashTag &&
                  findHashTag(
                    this.state.resultSearch?.contents,
                    this.state.searchInput.slice(1).trim()
                  )
                    .slice(0, 10)
                    .map((tag, index) => {
                      return (
                        <div
                          className="container-tag w-100"
                          key={index}
                          onClick={() => {
                            this.isFocus(false);
                            this.props.history.push({
                              pathname: `/Hashtags/${tag.tag}`,
                            });
                          }}
                        >
                          <div className="hashtag-search">
                            <div className="hashtag-search-icon">
                              <p className="hashtag-search-icon-content">#</p>
                            </div>
                            <div className="tag">
                              <p className="tag-title">#{tag.tag}</p>
                              <p className="tag-subtitle">
                                {tag.numberContent} contents
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
              </div>
            )}

            {!this.state?.loadingSearch && !this.state.listUsers.length && (
              <p>No result</p>
            )}

            {!this.state?.isSearchHashTag && this.state?.listUsers && (
              <div className="pourToiListItem row mx-0 px-1">
                {this.state?.listUsers?.map((item, index) => {
                  return (
                    <div
                      className={`pointer-cursor px-0 col-md-12`}
                      key={index}
                      onClick={() => {
                        this.isFocus(false);
                        this.props.history.push({
                          pathname: `/details-user/${item?.pseudo}`,
                          id: item?.id,
                        });
                      }}
                    >
                      <SearchResultWebPourToi
                        img={item?.profil}
                        title={`${item?.pseudo}`}
                        description={`${item?.pseudo}`}
                        userId={item?.id}
                      />
                    </div>
                  );
                })}
              </div>
            )}
            {this.state.type === "hashtag" &&
              this.state.resultSearch.length &&
              this.state.resultSearch.map((hashtag) => {
                return (
                  <div className="hashtag-search">
                    <div className="hashtag-search-icon">
                      <p className="hashtag-search-icon-content">#</p>
                    </div>
                    <div className="tag">
                      <p className="tag-title">#{hashtag.tag.tag}</p>
                      <p className="tag-subtitle">{13} contents</p>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    );
  };

  redirect = (page) => {
    let link = "";
    if (page === "home") {
      link = "/";
    } else if (page === "login") {
      link = "/login";
    }
    this.props.history.push(link);
  };

  renderLinkMessage = (icone) => {
    return (
      <Link
        to={this.props.isConnect ? `/messages` : `/login`}
        style={{ textDecoration: "none" }}
      >
        <img height={30} src={icone} alt="" />
        {this.props.messageCount > 0 ? (
          <Badge variant="danger" className="badge-counter">
            {this.props.messageCount}
          </Badge>
        ) : null}
      </Link>
    );
  };

  size = (obj) => {
    const objectLenght = Object.keys(obj).length;
    return objectLenght;
  };

  // Delete notification
  onRenderPopOverDeleteNotification = (taille, notificationId) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Content>
          <div className="d-flex flex-column pointer-cursor">
            <span>Delete</span>
          </div>
        </Popover.Content>
      </Popover>
    );

    return (
      <OverlayTrigger
        trigger="click"
        placement="bottom"
        overlay={popover}
        onHide={() => {}}
        rootClose
      >
        <img
          src={points}
          alt=""
          style={{ width: taille + "px", height: taille + "px" }}
          className="ml-1"
        />
      </OverlayTrigger>
    );
  };

  onMouseOver(e) {
    this.setState({
      styleButtonNotification: {
        display: "block",
        position: "absolute",
        top: "0px",
        right: "10px",
        zIndex: 5,
      },
    });
  }

  onMouseOut(e) {
    this.setState({
      styleButtonNotification: {
        display: "none",
        position: "absolute",
        top: "0px",
        right: "10px",
        zIndex: 5,
      },
    });
  }

  onRenderProfile = (image) => {
    const badgePosition = {
      position: "relative",
      left: "-5px",
      top: "-10px",
    };
    const style = { textDecoration: "none", color: "black" };

    const popover = (
      <Popover id="popover-basic" className="mt-3">
        <Popover.Content className="k-semibold-15 pt-2">
          <Link
            to={"/MonCompte"}
            style={{
              textDecoration: "none",
              color: "black",
              position: "relative",
            }}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt underline-txt mt-1" data-cy="compte">
              Compte
            </p>
          </Link>
          <span style={{ position: "absolute", top: "-10px", right: "-10px" }}>
            {this.props.total > 100 ? "+99" : this.props.total}
          </span>

          <Link
            to={"/MonProfil"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt underline-txt">Profil</p>
          </Link>
          <Link
            to={"/notification"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt underline-txt">Notifications</p>
          </Link>
          <Link
            to={"/"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt">Messages</p>
          </Link>
          <Link
            to={"/Wishlist"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt">Favoris</p>
          </Link>
          <Link
            to={"/ViePrivee"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt">Paramètres</p>
          </Link>
          <Link
            to={"/orders"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt">Commandes</p>
          </Link>
          <Link
            to={""}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt">Help</p>
          </Link>
          <Link
            to={""}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
          >
            <p className="underline-txt mb-0">Publier</p>
          </Link>
        </Popover.Content>
      </Popover>
    );
    return (
      <>
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          overlay={popover}
          rootClose
        >
          <img src={image} alt="" className="rounded-pill rounded_40" />
        </OverlayTrigger>
      </>
    );
  };

  onRenderWishlist = () => {
    const style = { textDecoration: "none", color: "black" };
    const stylePopover = {
      position: "absolute",
      zIndex: "5",
    };

    const handlerClickPopOver = (event) => {
      this.setState({ targetPopOver: event.target });
    };

    const popover = (
      <Popover id="popover-basic" style={stylePopover} ref={this.wrapperRef}>
        <Popover.Content className="k-semibold-15">
          <Link
            to={"/Wishlist"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
            onClick={() => {
              this.setState({ show: false });
            }}
          >
            <p className="underline-txt underline-txt mt-1">Favorites</p>
          </Link>
          <Link
            to={"/notification"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
            onClick={() => {
              this.setState({ show: false });
            }}
          >
            <p className="underline-txt">History</p>
          </Link>
          <Link
            to={"/notification"}
            style={style}
            className="d-flex flex-row justify-content-between pointer-cursor"
            onClick={() => {
              this.setState({ show: false });
            }}
          >
            <p className="underline-txt mb-0">Last views</p>
          </Link>
        </Popover.Content>
      </Popover>
    );
    return (
      <>
        <img
          src={Bise}
          alt=""
          width={"60%"}
          onClick={(event) => {
            this.setState({ show: true });
            handlerClickPopOver(event);
          }}
          ref={(button) => {
            this.target = button;
          }}
        />

        <Overlay
          placement="bottom"
          show={this.state.show}
          rootClose
          target={this.state.targetPopOver}
        >
          {popover}
        </Overlay>
      </>
    );
  };

  onRenderLikes = (width) => (
    <Link to={`/Wishlist`} style={{ textDecoration: "none" }}>
      <img src={ic_coeur} alt="" width={`${width}px`} />
    </Link>
  );

  onRenderPanier = (width) => (
    <Link
      to={`/Panier/${this.props.user.pseudo}`}
      style={{ textDecoration: "none", position: "relative" }}
    >
      <Badge
        variant="danger"
        style={{
          position: "absolute",
          right: "-7px",
          top: "-100px",
        }}
      >
        {this.props.paniersCount}
      </Badge>

      <span style={{ position: "absolute", top: "-10px", right: "-10px" }}>
        {this.props.paniersCount}
      </span>
      <img
        src={panier}
        alt="..."
        className="img-fluid rounded-circle rounded_20"
        width={`${width}px`}
      />
    </Link>
  );

  render() {
    return (
      <Navbar
        sticky="top"
        className="mb_header navbar floatingNav"
        collapseOnSelect
        expand="md"
      >
        {this.props.location.pathname === "/" && <ModalHome />}
        {this.state.showLoading && (
          <div
            style={{
              position: "absolute",
              top: "0",
              zIndex: 8,
            }}
            className="w-75 text-center"
          >
            <BounceLoader color={"orange"} loading={true} size={100} />
          </div>
        )}{" "}
        {this.props.location.pathname !== "/" && (
          <Navbar.Brand onClick={() => this.props.history.goBack()}>
            <IoIosArrowBack
              size={30}
              color="#393939"
              className="d-block d-lg-none"
            />
          </Navbar.Brand>
        )}
        <Navbar.Brand onClick={() => this.redirect("home")}>
          <img
            src={logo}
            alt="Logo"
            className="d-none d-lg-block pointer-cursor"
          />
          <img
            src={logoMobile}
            alt="Logo"
            className="d-block d-lg-none mybeedoo-logo"
          />
        </Navbar.Brand>
        <Navbar.Collapse className="pt-1">
          <div
            className="mx-auto d-flex flex-column flex-md-row justify-content-center"
            style={{ width: "70%" }}
          >
            {this.onRenderSearchForm()}
            <div className="d-flex headerMenu justify-content-between">
              <Nav.Link as={Link} to={`/Photos`}>
                <div className="d-flex align-items-center">
                  <div id="photos" />
                  <span>Pictures</span>
                </div>
              </Nav.Link>
              <Nav.Link as={Link} to={`/Videos`}>
                <div className="d-flex align-items-center">
                  <div id="videos" />
                  <span>Videos</span>
                </div>
              </Nav.Link>
              <Nav.Link as={Link} to={`/Tags`}>
                <div className="d-flex align-items-center">
                  <div id="tags" />
                  <span>Tags</span>
                </div>
              </Nav.Link>{" "}
              <Nav.Link as={Link} to={`/Shopping`}>
                <div className="d-flex shopping align-items-center">
                  <div className="customYellow rounded-pill text-center mr-1">
                    <img id="shopping" src={panier} alt="" />
                  </div>
                  <span>Shopping</span>
                </div>
              </Nav.Link>
            </div>
          </div>

          {this.props.isConnect ? (
            <div
              className="d-flex justify-content-around"
              style={{ minWidth: "200px" }}
            >
              <Link
                to={`/panier/${this.props.user.pseudo}`}
                className="header-flex-item d-flex justify-content-center align-items-center"
              >
                <img src={panier} alt="" width="25px" />
              </Link>
              {this.props.paniersCount > 0 && (
                <div
                  style={{
                    marginLeft: "-15px",
                  }}
                >
                  <sup
                    style={{
                      backgroundColor: "#dc3545",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "12px",
                      width: "22px",
                      height: "22px",
                      color: "#FFF",
                      outline: "3px white solid",
                      borderRadius: "50%",
                      padding: "4px",
                    }}
                  >
                    {this.props.paniersCount}
                  </sup>
                </div>
              )}
              <div className="header-flex-item header-kiss d-flex justify-content-center align-items-center">
                {this.onRenderWishlist()}
              </div>
              <Link to={"/MonCompte"} data-cy="moncompte">
                <div style={{ position: "relative" }}>
                  <ImageComponent
                    widthParent={"36px"}
                    heightParent={"36px"}
                    isRounded={true}
                    src={
                      this.props.user && this.props.user.profil
                        ? this.props.user.profil
                        : defaultProfile
                    }
                    alt=""
                  />
                  {this.props.total > 0 && (
                    <div
                      data-cy="totalCompte"
                      style={{
                        outline: "3px white solid",
                        backgroundColor: "#dc3545",
                        position: "absolute",
                        top: "-5px",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        right: "-12px",
                        fontSize: "12px",
                        width: "22px",
                        height: "22px",
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                        color: "#FFF",
                        borderRadius: "50%",
                        padding: "4px",
                      }}
                    >
                      {encryptionNotification(this.props.total)}
                    </div>
                  )}
                </div>
              </Link>

              <Link
                to={"/new-publication"}
                className="header-flex-item bg-light d-flex justify-content-center align-items-center coeur"
              >
                <img src={plus} alt="" className="blink2" width="25px" />
              </Link>
            </div>
          ) : (
            <Nav>
              <button
                className="btn btn-yellow btn-rounded k-semibold-15"
                onClick={() => this.redirect("login")}
              >
                Sign in
              </button>
            </Nav>
          )}
        </Navbar.Collapse>
        {/* Icones Mobile */}
        <div className="d-block d-md-none d-flex">
          {this.props.isConnect && (
            <>
              <div className="mr-3 my-auto"> {this.onRenderPanier(25)}</div>
              <div className="mr-2 my-auto">{this.onRenderLikes(25)}</div>{" "}
              <div className="mr-1 my-auto">
                {this.renderLinkMessage(envMail)}
              </div>
              <div
                className="my-auto"
                onClick={() => {
                  this.props.history.push("/Notification");
                }}
              >
                <img
                  width={45}
                  height={45}
                  src={notif}
                  alt=""
                  style={{ marginRight: "-15px" }}
                />
              </div>
            </>
          )}
        </div>
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isConnect: state.compteReducers.isConnected,
    user: state.compteReducers.userConnected,
    paniersCount: state.paniersReducers.paniersCount,
    total: state.counterReducers.totalCount,
    newItemsCount: state.counterReducers.newItemsCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    setPaniersCounterReset: (data) => {
      return dispatch(setPaniersCounterReset(data));
    },
    setPaniersCounter: (data) => {
      return dispatch(setPaniersCounter(data));
    },
    setPaniersCounterAdd: (data) => {
      return dispatch(setPaniersCounterAdd(data));
    },
    setCouterNotification: (data) => {
      return dispatch(setCouterNotification(data));
    },
    setCouterOrder: (data) => {
      return dispatch(setCouterOrder(data));
    },
    setTotalCounter: (data) => {
      return dispatch(setTotalCounter(data));
    },
    setCouterMessage: (data) => {
      return dispatch(setCouterMessage(data));
    },
    updateNewItemsCount: (data) => {
      return dispatch(updateNewItemsCount(data));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));

export const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a // eslint-disable-line jsx-a11y/anchor-is-valid
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    {/* &#x25bc; */}
    <img src={down} alt="" />
  </a>
));
